export default "__VITE_ASSET__35361d69__"